import React, { PureComponent } from "react";
import { push } from "react-router-redux";
import { connect } from "react-redux";

import { selectLoggedAs } from "Selectors";

import CollaboratorPresentations from "./CollaboratorPresentations";
import CollaboratorSpaceCalendar from "./CollaboratorSpaceCalendar";
import CollaboratorClientFolders from "./CollaboratorClientFolders";
import CollaboratorPerformances from "./CollaboratorPerformances";
import CollaboratorSpaceFilter from "./CollaboratorSpaceFilter";
import CollaboratorSpaceAside from "./CollaboratorSpaceAside";
import NotFoundV2 from "../NotFound/NotFoundV2";

import collaboratorApi from "../../services/CollaboratorServices";
import styles from "./CollaboratorSpace.local.scss";
import classnames from "classnames";
import { setYearFilterCollaborators } from "Actions";
import { getUrlProperties } from "Utils";

class CollaboratorSpace extends PureComponent {
  //******************   Content Functions  **************//

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      error: false,
      collaborator: null,
      year: this.props.yearFilter,
      getYearHeader: false
    };
    const params = new Map(
      window.location.search
        .slice(1)
        .split("&")
        .map(kv => kv.split("="))
    );
    if (!params.has("year")) {
      const url = new URL(window.location);
      url.searchParams.set("year", this.props.yearFilter);
      window.history.replaceState({}, "", url);
    }
  }

  componentDidMount() {
    let { organization, yearFilter, dispatch } = this.props;
    let id = this.props.id ? this.props.id : null;
    let apiId = this.props.id ? null : this.props.user.id;

    this.setState({ loading: true });
    collaboratorApi
      .getCollaboratorByIdOrApiId(organization.uen, id, apiId)
      .then(resp => {
        let response = resp.data.data;
        this.setState({
          collaborator: response,
          loading: false
        });
      })
      .catch(error => {
        this.setState({ error: true, loading: false });
      });
    let year = yearFilter;
    const params = getUrlProperties();
    if (params.has("year")) {
      year = params.get("year");
      dispatch(setYearFilterCollaborators(year));
    } else if (!this.state.getYearHeader) {
      const url = new URL(window.location);
      url.searchParams.set("year", year);
      window.history.replaceState({}, "", url);

      this.setState({
        ...this.state,
        getYearHeader: true
      });
    }
    this.setState({
      ...this.state,
      year: year
    });
  }

  handleFilterChange = year => {
    let { collaborator } = this.state;
    this.props.dispatch(push(`/collaborator-space/${collaborator.id}`));
  };

  render() {
    let { collaborator, year, loading, error } = this.state;
    let {
      organization,
      lng,
      from,
      dispatch,
      synchro,
      spaceAs,
      loggedAs,
      appsState,
      withoutHeader
    } = this.props;

    return (
      <div>
        {loading && (
          <div className={styles.ripple_loading}>
            <img src={"/img/Ripple-1s-150px.svg"} alt="" />
          </div>
        )}
        {error ? (
          <div className={styles.error_frame}>
            <NotFoundV2
              errorPageType={"ACCESS_DENIED"}
              text={"noAccessCollaborator"}
              buttonIgnored={1}
            />
          </div>
        ) : (
          !loading &&
          collaborator && (
            <div
              className={classnames(
                styles.page_content,
                withoutHeader ? styles.without_header : ""
              )}
            >
              <CollaboratorSpaceAside
                user={collaborator}
                language={lng}
                organization={organization}
              />
              <div className={styles.block_content}>
                <CollaboratorSpaceFilter
                  year={year}
                  loggedAs={loggedAs}
                  spaceAs={spaceAs}
                  user={collaborator}
                  dispatch={dispatch}
                  organization={organization}
                  onChangeFilter={this.handleFilterChange}
                />
                <div className={styles.section_block}>
                  <div className={styles.principal_section}>
                    {synchro ? (
                      <CollaboratorPerformances
                        year={year}
                        user={collaborator}
                        dispatch={dispatch}
                        synchro={synchro}
                        organization={organization}
                      />
                    ) : (
                      ""
                    )}
                    <CollaboratorPresentations
                      lng={lng}
                      year={year}
                      user={collaborator}
                      dispatch={dispatch}
                      synchro={synchro}
                      appsState={appsState}
                      organization={organization}
                      withoutHeader={withoutHeader}
                    />
                  </div>
                  <div className={styles.second_section}>
                    {!synchro ? (
                      <CollaboratorPerformances
                        year={year}
                        user={collaborator}
                        dispatch={dispatch}
                        synchro={synchro}
                        organization={organization}
                      />
                    ) : (
                      ""
                    )}
                    <CollaboratorClientFolders
                      year={year}
                      dispatch={dispatch}
                      user={collaborator}
                      synchro={synchro}
                      organization={organization}
                      withoutHeader={withoutHeader}
                      spaceAs={spaceAs}
                    />
                    <CollaboratorSpaceCalendar
                      user={collaborator}
                      from={from}
                      year={year}
                      synchro={synchro}
                      organization={organization}
                    />
                  </div>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  lng: state.params.lng,
  loggedAs: selectLoggedAs(state),
  spaceAs: state.auth.spaceAs,
  organization: state.auth.currentOrganization,
  synchro: state.fiduciary.data && state.fiduciary.data.synchro,
  appsState:
    state.auth.currentOrganization && state.auth.currentOrganization.appsState,
  yearFilter: state.collaboratorList.yearFilter
});

export default connect(mapStateToProps)(CollaboratorSpace);



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorSpace.js